
  import { Vue, Component, Prop } from "vue-property-decorator";
  import GET_SUITABLE_RESOURCES from "@/apollo/requests/GetSuitableResources.gql";
  import CardBodyItem from "@/components/card/CardBodyItem.vue";
  import SuitableResourcesPlaceholder
    from "@/components/skeletonPlaceholder/components/SuitableResourcesPlaceholder.vue";
  import ItemChipsWithMore from "@/components/common/ItemChipsWithMoreNew.vue";
  import { User, User_Bool_Exp } from "@/generated/graphql";
  import ItemChipsData from "@/entities/ItemChipsData";
  import getFullName from "@/helpers/getFullName";
  import RouteNames from "@/entities/RouteNames";
  import RouteParams from "@/entities/RouteParams";
  import { delimiter } from "@/helpers/router/prepareFiltersQuery";

  interface ResourceQueryArgs {
    where: User_Bool_Exp,
    companyId: string,
  }

  @Component({
    components: {
      ItemChipsWithMore,
      SuitableResourcesPlaceholder,
      CardBodyItem
    },
    apollo: {
      suitableResources: {
        query: GET_SUITABLE_RESOURCES,
        variables(): ResourceQueryArgs {

          const exclude = !this.excludeResourceUserId ? {} : {
            id: {
              _neq: this.excludeResourceUserId,
            },
          };

          return {
            companyId: this.companyId,
            where: {
              _and: [
                exclude,
                {
                  profile: {
                    skills: {
                      skill_id: {
                        _in: this.skillIds,
                      },
                    },
                  },
                },
              ],
            },
          };
        },
        update(data) {
          let suitable = data.user.filter((user: User) => {
            return user.contracts.length > 0;
          });
          this.resourcesCount = suitable.length;
          return suitable;
        },
      },
    },
  })
  export default class SuitableResources extends Vue {
    @Prop({ type: String, required: true }) readonly companyId!: string;
    @Prop({ type: Array, required: true }) readonly skillIds!: string[];
    @Prop({ type: String, default: undefined }) readonly excludeResourceUserId?: string;

    suitableResources: User[] = [];
    resourcesCount: number = 0;

    get isLoading(): boolean {
      return this.$apollo.queries.suitableResources.loading;
    }

    get suitableContractors(): ItemChipsData[] {
      return this.suitableResources.map(user => {
        const {
          given_name: givenName,
          family_name: familyName,
          id,
        } = user;

        const contractorId = user.contracts[0]?.id;
        const contractorPublicPageRoute = {
          name: RouteNames.CONTRACTOR_PUBLIC_PAGE,
          params: {
            id,
          },
        };
        const contractorPrivatePageRoute = {
          name: RouteNames.CONTRACTOR_DETAILS_ABOUT,
          params: {
            id: contractorId,
          },
        };

        const routeParams = contractorId ? contractorPrivatePageRoute : contractorPublicPageRoute;

        return {
          id,
          name: getFullName(givenName!, familyName!),
          highlighted: Boolean(contractorId),
          avatar: user.avatar!,
          routeParams,
        };
      }).sort((first, second) => (first.highlighted && second.highlighted) ? -1 : 1);
    }

    get resourcesExist(): boolean {
      return !this.isLoading && this.resourcesCount > 0;
    }

    get moreResourcesLink(): RouteParams<any> {
      return {
        name: RouteNames.MARKETPLACE_CONTRACTORS,
        query: {
          skills: this.skillIds.join(delimiter),
          suitable_resources: true,
          exclude_resource: this.excludeResourceUserId,
        },
      };
    }
  }
